export default __webpack_public_path__ + "static/media/trr-food-worb_southwest.b8171476.png";